import Pochta from "./Pochta";
function INFP()
{
     return(
        <div className="Glavn">
  <div className='catalog' >
        <div className="image">
            <div className="image-wrapper">
      <img src="/img/INFP Посредник.png" className="INFP"/>
      </div>
      {/* <h1>Дипломат</h1>
      <h2>ENFP</h2> */}
       <div className="result">
         <h2>INFP</h2>
   <p><strong>Процент населения:</strong> 4–5%</p>
<p><strong>Среди мужчин:</strong> 3–4%</p>
<p><strong>Среди женщин:</strong> 4–6%</p>
<p><strong>Стратегия:</strong> Поиск смысла</p>

<p><strong>Психологические особенности:</strong></p>
<p>
  INFP черпают энергию в одиночестве и творчестве. 
  Им нужно время, чтобы погрузиться в свой внутренний мир и понять себя. 
  Они восстанавливают силы через искусство, музыку или письмо.
</p>
<p>
  Решения INFP принимают на основе ценностей и чувств. 
  Они доверяют своему сердцу и редко идут против совести. 
  Они ценят искренность, доброту и возможность быть собой.
</p>
<p>
  Это идеалисты и мечтатели. 
  Они всегда ищут гармонию и хотят делать мир добрее. 
  Им трудно принимать реальность, но их доброта согревает.
</p>

<p><strong>Особенность:</strong></p>
<p>
  INFP живут в мире идеалов, а не фактов. Они расстраиваются, когда мир не соответствует их ожиданиям. 
  Они принимают всё близко к сердцу и могут долго переживать даже мелочи. 
  Им трудно говорить «нет», и они часто жертвуют собой ради других. 
  Их ранимость делает их сложными, но их внутренний мир прекрасен.
</p>

<p>
  INFP — это душа, которая поет, даже когда всё вокруг молчит. Они могут написать стихотворение, 
  которое заставит плакать, и никогда его никому не показать. Они живут в мире, где добро всегда побеждает, 
  и верят в это так сильно, что иногда мир действительно становится лучше. Они — сердце человечества.
</p>

  </div>
  <Pochta/>
  </div>
   </div>
    </div>
       );
}
export default INFP;